// Wrath (Mars): consonants are worth more at the base.
import { ALIGNMENT_NUMBERS as N } from '../constants';
import { isVowel } from '../shared/letters';
import type { AlignmentDef } from '../types';

export const wrath: AlignmentDef = {
  id: 'wrath',
  planet: 'mars',
  name: 'Wrath',
  text: () => `Consonants have +${N.wrathAdd} base value.`,
  baseAdd: (star) => (isVowel(star.node.letter) ? 0 : N.wrathAdd),
};
